import { render } from "./RolePermission.vue?vue&type=template&id=3388f4fc&scoped=true"
import script from "./RolePermission.vue?vue&type=script&lang=js"
export * from "./RolePermission.vue?vue&type=script&lang=js"

import "./RolePermission.vue?vue&type=style&index=0&id=3388f4fc&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3388f4fc"]])

export default __exports__